import React, { useEffect, useState } from "react";
import { RefreshCw, X } from "lucide-react";
import {
  activateUpdateAndReload,
  startManifestUpdatePolling,
  subscribeToAppUpdates,
} from "../utils/appUpdateManager";
import ElsaAdaptiveEmblem from "./branding/ElsaAdaptiveEmblem";
import "./AppUpdatePrompt.css";

const AppUpdatePrompt = () => {
  const [updateDetails, setUpdateDetails] = useState(null);
  const [isDismissed, setIsDismissed] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    const stopPolling = startManifestUpdatePolling();
    const unsubscribe = subscribeToAppUpdates((details) => {
      setUpdateDetails(details);
      setIsDismissed(false);
    });

    return () => {
      unsubscribe();
      stopPolling();
    };
  }, []);

  const handleRefresh = async () => {
    if (isRefreshing) {
      return;
    }

    setIsRefreshing(true);
    await activateUpdateAndReload();
  };

  if (!updateDetails || isDismissed) {
    return null;
  }

  return (
    <aside className="app-update-prompt" aria-live="polite">
      <button
        type="button"
        className="app-update-prompt__close"
        onClick={() => setIsDismissed(true)}
        aria-label="Masquer la mise a jour"
        disabled={isRefreshing}
      >
        <X size={18} aria-hidden="true" />
      </button>

      <div className="app-update-prompt__brand" aria-hidden="true">
        <ElsaAdaptiveEmblem className="app-update-prompt__logo" alt="" />
        <span className="app-update-prompt__brand-badge">
          <RefreshCw size={12} />
        </span>
      </div>

      <div className="app-update-prompt__content">
        <div className="app-update-prompt__eyebrow">ELSA GESTION</div>
        <h2 className="app-update-prompt__title">
          Nouvelle mise à jour disponible
        </h2>
        <p className="app-update-prompt__description">
          Actualisez l'application pour charger les dernieres corrections et
          ameliorations.
        </p>

        <div className="app-update-prompt__actions">
          <button
            type="button"
            className="app-update-prompt__primary"
            onClick={handleRefresh}
            disabled={isRefreshing}
          >
            <RefreshCw
              size={16}
              className={isRefreshing ? "app-update-prompt__spin" : ""}
              aria-hidden="true"
            />
            {isRefreshing ? "Actualisation..." : "Actualiser"}
          </button>

          <button
            type="button"
            className="app-update-prompt__secondary"
            onClick={() => setIsDismissed(true)}
            disabled={isRefreshing}
          >
            Plus tard
          </button>
        </div>
      </div>
    </aside>
  );
};

export default AppUpdatePrompt;
